import React from 'react';

interface ProductOptionGroupProps {
  name: string;
  options: string[];
  selected?: string;
  onChange: (value: string) => void;
}

export const ProductOptionGroup: React.FC<ProductOptionGroupProps> = ({
  name,
  options,
  selected,
  onChange,
}) => {
  return (
    <div className="mt-4">
      <div className="text-[16px] mb-2" style={{ fontFamily: 'var(--font-body)', color: 'var(--color-text-secondary)' }}>{name}</div>
      {/* Single row with horizontal scroll if overflow */}
      <div className="flex gap-2 overflow-x-auto no-scrollbar">
        {options.map((option) => {
          const isSelected = selected === option;
          return (
            <button
              key={option}
              onClick={() => onChange(option)}
              className="ww-btn ww-btn-third whitespace-nowrap"
              style={{
                borderColor: isSelected ? 'var(--primary)' : undefined,
                opacity: isSelected ? 1 : 0.5,
              }}
              aria-pressed={isSelected}
            >
              {option}
            </button>
          );
        })}
      </div>
    </div>
  );
};


